import React, { useState } from "react";
import FriendRequestsTabDisplay from "./components/friendRequestsTabDisplay/FriendRequestsTabDisplay.js";
import FriendsListTabDisplay from "./components/friendsListTabDisplay/FriendsListTabDisplay.js";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { useMediaQuery } from "@mui/material";

import "./FriendsPage.css";

const FriendsPage = ({
  accessToken,
  setDisplayError,
  userData,
  setPopupType,
  setShowPopup,
  isUserOnIos
}) => {
  const [value, setValue] = useState("friends");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const isMobile = useMediaQuery("(max-width:800px)");

  return (
    <div className="friendsPage">
      <Tabs
        value={value}
        onChange={handleChange}
        style={{ marginBottom: "1.5rem" }}
        centered={isMobile}
      >
        <Tab label="Friends" value="friends" style={{ color: "white" }} />
        <Tab label="Requests" value="requests" style={{ color: "white" }} />
      </Tabs>
      {value === "friends" && (
        <div>
          <FriendsListTabDisplay
            accessToken={accessToken}
            setDisplayError={setDisplayError}
            setPopupType={setPopupType}
            setShowPopup={setShowPopup}
            isUserOnIos={isUserOnIos}
          />
        </div>
      )}
      {value === "requests" && (
        <FriendRequestsTabDisplay
          accessToken={accessToken}
          userData={userData}
          setDisplayError={setDisplayError}
        />
      )}
    </div>
  );
};

export default FriendsPage;
